import * as React from 'react'
function SvgArchive(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 4H6c-1.2 0-2 .8-2 2v28c0 1.2.8 2 2 2h28c1.2 0 2-.8 2-2V6c0-1.2-.8-2-2-2zm-2 4v14h-6c-1.2 0-2 .8-2 2v4h-8v-4c0-1.2-.8-2-2-2H8V8h24z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgArchive
